<template>
    <Widget title="Announcements"
        headerLink="announcements"
        :iconSrc="require('../../../assets/images/home_icons/announcements.png')"
    >
        <div class="d-flex flex-column h-100">
            <div class="d-flex justify-content-between">
                <button class="btn btn-sm btn-light" @click="goToAnnouncementsPage">
                    <i class="fas fa-list-ul"></i>
                    Announcement List
                </button>

                <button type="button" class="btn btn-sm btn-light" @click="stopActiveAnnouncements">
                    <i class="fa fa-stop fa-fw" aria-hidden="true"></i>
                    Stop Active
                </button>
            </div>

            <Announcements />

            <div class="text-right mt-auto">
                <button type="button" class="btn btn-sm btn-light mt-2" data-toggle="modal" data-target="#textToSpeechModal"
                    v-show="is_authenticated" v-if="[1, 2, 3, 4, 5].includes(logged_in_user.group_id)">
                    <i class="fa fa-keyboard fa-fw" aria-hidden="true"></i> 
                    Text-to-Speech
                </button>
            </div>

            <Modal modal_id="textToSpeechModal">
                <template #title>
                    <h5>Text-to-Speech</h5>
                </template>
                <template #body>
                    <TextToSpeechForm :callback="textToSpeechCallback"/>
                </template>
            </Modal>
        </div>
    </Widget>
</template>

<script>
import { mapGetters } from 'vuex';
import router from '../../../router';
import Widget from '../Widget.vue';
import Modal from '../../Modal.vue';
import Announcements from './Announcements.vue';
import TextToSpeechForm from '../../Announcement/TextToSpeechForm.vue';

export default {
    components: { Widget, Announcements, Modal, TextToSpeechForm },
    computed: {
        ...mapGetters({
            logged_in_user: 'loggedInUser',
            is_authenticated: 'isAuthenticated',
        })
    },
    methods: {
        goToAnnouncementsPage() {
            router.push('announcements')
        },
        stopActiveAnnouncements() {
            this.g2dialog.$confirm('You are about to stop active announcements. Continue?')
                .then(confirmed => confirmed && this.$store.dispatch('stopActiveAnnouncements'))
        },
        hideTextToSpeechModal() {
            $('#textToSpeechModal').modal('hide')
        },
        textToSpeechCallback(status) {
            if(status === 'failure') return;
            this.hideTextToSpeechModal(); 
        }
    }
}
</script>